export default {
	singapore: 'Singapore',
	thailand: 'Thailand',
	malaysia: 'Malaysia',
	education_calculator: 'Education Calculator',
	see_how_much:
		'See how much children education can cost in {entity} and abroad, and how to fund them',
	financing_for_education:
		'Financing for education can be tough and will require careful planning. Let’s see what we can do to make it more manageable for you.',
	next: 'Next',
	back: 'Back',
	your_childs_profile: "Your child's profile",
	let_me_help: 'Let me help you',
	estimations_only: '*Estimations only, refer to your trusted financial advisers for more info',
	grow_your_education_savings:
		'Grow your education savings more by choosing the right financial product',
	each_year: '% each year',
	assuming_your_money: 'Assuming your money will grow by',
	year: 'year*',
	base_your_goal: 'Based on your goal of ',
	education_cost_brief:
		'Cost inclusive of tution fee and living cost (For where these figures are obtained, please see available <i> <a href="https://support.goalsmapper.com/hc/en-us/articles/900004799406-How-is-the-data-for-the-Education-Planner-widget-collected-" rel="noopener noreferrer" target="_blank"> references</a></i>.)',
	where_to_study: 'Where do you want them to study?',
	education_study_destination: 'Study Destination',
	field_of_study: 'Field of study',
	year_of_study: 'Year of Study',
	year_singular: 'Year',
	years_to_enrolment: 'Years to Enrolment',
	age: 'Age',
	foreigner: 'Foreigner',
	citizen_pr: 'Citizen/PR',
	what_residency_status: "What's your residency status?",
	child_field_of_study: "Your child's Field of Study",
	university_age: 'Age entering University',
	childs_age: "Child's Age",
	start_telling: "Start by telling us your child's profile",
	set_aside: 'you have to set aside ',
	profile: 'Profile',
	plan: 'Plan',
	total_cost_includes: 'Total cost includes',
	ok: 'Ok',
	annual_cost_from: 'Annual cost from ',
	today: 'Today',
	select: 'Select',
	death: 'Death',
	critical_illness: 'Critical Illness',
	disability_tpd: 'Disability (TPD)',
	insurance_coverage_brief: 'Tell us your current insurance coverage',
	profile_brief: 'Start by telling us your profile',
	these_information:
		'These information help us in understanding the basis of your insurance needs.',
	your_age: 'Your age',
	your_gender: 'Your gender',
	your_life_expectancy: 'Your Life Expectancy',
	insurance_estimation:
		'*Estimates based on the data from <a target="_blank" rel="noopener noreferrer" href="https://www.worldometers.info/demographics/life-expectancy/">Worldometers.info</a>',
	your_monthly_expense: 'Your monthly expense',
	mandatory_field: '" (mandatory field)"',
	see_below: 'See below for the summary of your coverage*',
	increase_your_coverage: 'Continue to see how you can increase your coverage',
	estimation_only: '*Estimations only, refer to your trusted financial advisers for more info',
	exisiting_coverage: 'Existing Coverage',
	coverage_needed: 'Coverage Needed',
	coverage_gap: 'Coverage Gap (Shortfall)',
	years: 'Years',
	what_if: 'What If...',
	what_if_one: 'What if...1',
	what_if_two: 'What If...2',
	questions_below:
		'Some of the questions below are highly “what if”. If you have difficulty answering a question, just try giving rough estimates or assumptions.',
	ci_event: 'In the event of critical illness, how many years would you like to be provided for?',
	disability_event:
		'In the event of disability, how many years would you like to be provided for?',
	passing_on: 'In the event of passing on…',
	provide_your_family: 'How much do you want to provide for your family?',
	month: 'Month',
	your_insurance: 'Your Insurance',
	planning_your_protection:
		'Planning your protection needs can be tough and will require careful planning. Let’s see what we can do to make it more manageable for you.',
	find_out_insurance: 'Find out if your existing insurance coverage is sufficient for you',
	based_on_your: 'Based on your inputs, you ',
	you_should_retire_by: 'Based on your inputs, you should be able to retire at the Age of ',
	your_monthly_income: 'Your monthly income',
	your_profile: 'Your profile',
	expect_to_live: 'Expect to live till',
	monthly_income: 'Monthly income',
	monthly_expense: 'Monthly expense',
	percent_each_year: '% each year.',
	adjust_growth_rate:
		'Adjust the growth rate of your savings, to see how it makes a difference to your retirement age.',
	let_me_show: 'Let me show you how to make your desired retirement age a reality.',
	retirement_planner: 'Retirement Planner',
	find_out_how_old:
		'Find out how old can you retire from your savings and spending patterns today',
	gender_required: 'Gender is a required field',
	age_required: 'Age is a required field',
	life_required: 'Life Expectancy is a required field',
	life_expectancy: 'Life Expectancy must be after current age',
	expense_required: 'Monthly expense is a required field',
	required_field: 'Required field',
	field: 'Field',
	positive_number: 'Must be a positive number',
	million: 'Million',
	shortfall: 'Shortfall',
	coverage: 'Coverage',
	please_check: 'Please check this box to continue',
	checked: 'checked',
	cannot_exceed: "Message can't exceed 500 characters.",
	phone_required: 'Phone number is a required field',
	name_required: 'Name is a required field',
	get_in_touch: 'Get in Touch',
	your_name: 'Your Name',
	your_mobile: 'Your Mobile',
	message: 'Message',
	success: 'Success!',
	in_touch_soon:
		"I'll get in touch with you soon. You can now close this page and return to my website for more information.",
	contact_disclaimer: `<div>I consent to the collection, use and disclosure of my personal data by
								{AGENT_NAME} for the following purposes
								<br />
								a. performing obligations in the course of or in connection with our
								provision of the goods and/or services requested by you;
								<br />
								b. sending you marketing information about our goods or services
								including notifying you of our marketing events, initiatives and
								promotions, lucky draws, membership and rewards schemes and other
								promotions;
								<br />
								c. complying with any applicable laws, regulations, codes of
								practice, guidelines, or rules, or to assist in law enforcement and
								investigations conducted by any governmental and/or regulatory
								authority;
								<br />
								d. any other purposes for which you have provided the information;
								<br />
								Please proceed if you agree to be contacted for the purposes above.</div>`,
	income_required: 'Monthly income is a required field',
	unable_retire: 'are unable to retire.',
	study_required: 'Field of Study is a required field',
	university_age_required: 'Age entering University is a required field.',
	study_country: 'Study country',
	living_expenses: 'Living Expenses',
	food: 'Food',
	transport: 'Transport',
	books: 'Books',
	accommodation: 'Accommodation',
	personal_expenses: 'Personal Expenses',
	all_citizenship: 'All Citizenship',
	pr: 'Permanent Resident',
	international: 'International',
	singaporean: 'Only Singaporean',
	tuition_fee: 'Tuition Fee',
	total_per_year: 'Total (per year)',
	accountancy: 'Accountancy',
	architecture: 'Architecture',
	arts: 'Arts',
	arts_science: 'Arts/Science',
	business: 'Business',
	computing: 'Computing',
	engineering: 'Engineering',
	law: 'Law',
	medicine: 'Medicine',
	music: 'Music',
	science: 'Science',
	aus: 'Australia',
	my: 'Malaysia',
	uk: 'United Kingdom',
	us: 'United States',
	sg: 'Singapore',
	th: 'Thailand',
	id: 'Indonesia',
	THB: 'THB',
	for_how_long: 'For how long?',
	private: 'Private',
	mortgage_planner: 'Mortgage Planner',
	mortgage_planner_subtitle: 'Have easy access to the most competitive mortgage rates and packages from major financial institutions. Simple, Fast, Convenient.',
	medical_concierge: 'Medical Concierge',
	medical_concierge_subtitle: 'Private Healthcare Services at your fingertips and Access to Network of Premier Medical Specialist.',
	gm_medical_concierge_title1: 'Connects you to Private Healthcare Services',
	gm_medical_concierge_description1:
		"GM Medical Concierge seamlessly links you to exclusive private healthcare services through strategic partnerships with premier Medical Concierge Service Providers.",
	gm_medical_concierge_title2: 'Access to Network of Premier Medical Specialist',
	gm_medical_concierge_description2:
		'GM Medical Concierge provides easy access to a network of top medical specialists, eliminating the need for time-consuming searches. <br/><br/>You can connect with expert specialists tailored to your unique needs, prioritizing convenience and offering optimal care.',
	gm_medical_concierge_title3: 'Timely Healthcare Access',
	gm_medical_concierge_description3:
		'GM Medical Concierge ensures prompt access to medical services through streamlined scheduling and efficient arrangements for specialized treatments. Strategic partnerships with healthcare providers minimize wait times, enabling you to address your needs promptly.',
	gm_medical_concierge_let_me_show: 'Let me assist you with this.',
	latest_mortgage_rates: 'Latest Mortgage Rates',
	loan_affordability: 'Loan Affordability',
	our_bank_partners: 'Our Bank Partners',
	rate_fix: 'Fixed',
	rate_var: 'Variable',
	rate_vbu: 'Variable (UC)',
	mortgage_lockin_period: 'Lock-in Period',
	mortgage_partial_prepayment: 'Partial Prepayment',
	mortgage_free_conversion: 'Free Conversion',
	mortgage_penalty_waiver: 'Waiver of Penalty (due to Sale)',
	mortgage_rebate_subsidy: 'Cash Rebate/Legal Subsidy',
	year1_interest: 'Year 1 Interest',
	year2_interest: 'Year 2 Interest',
	year3_interest: 'Year 3 Interest',
	year4_interest: 'Year 4 Interest',
	year5_interest: 'Year 5 Interest',
	thereafter_interest: 'Thereafter Interest ',
	min_loan_amount: 'Minimum Loan Amount',
	interest_rate_display: '<strong>[{realRate}]</strong> {rateString}',
	mortgage_packages_last_updated: 'Information last updated at {lastUpdated}',
	available_amount: 'Available Amount',
	tdsr_description:
		'TDSR is calculated by dividing monthly debt repayments by gross monthly income. This calculation is based on information provided by the client.',
	total_tdsr: 'Total TDSR',
	available_tdsr: 'Available TDSR',
	current_tdsr: 'Current TDSR',
	affordability_details: 'Affordability Details',
	private_ec_affordability: 'Private and EC Properties',
	private_bank_affordability: 'Loan Below 55% of Purchase Price',
	hdb_affordability: 'HDB Properties',
	income_weighted_average_age: 'Income Weighted Average Age',
	recognised_income: 'Recognised Monthly Income',
	current_debt: 'Current Monthly Debt',
	max_loan_tenure_hdb: 'Max Loan Tenure (HDB)',
	max_loan_tenure_private_ec: 'Max Loan Tenure (Private/EC)',
	max_loan_tenure_below_55: 'Max Loan Tenure (< 55% Purchase Price)',
	median_interest: 'Median Interest',
	monthly_mortgage_limit: 'Monthly Mortgage Limit for {ownership}',
	joint_liability_disclaimer:
		'Cash payment for Joint liability will be distributed evenly between client and spouse.',
	contact_mortgage_specialist: 'Contact GM Mortgage Specialist',
	variable_income_description: 'This includes rental income, bonuses and commissions.',
	tdsr_total_income_description:
		'Total Income calculated by taking 100% of monthly gross income + 70% of monthly variable income',
	tdsr_limit_description:
		'Total Maximum Income that you can use for your debt servicing (capped at 55%)',
	available_tdsr_description:
		'Total Available Income that you can use for new debt taking into consideration the current debt that you are already servicing.',
	current_tdsr_description: 'Total Current Income that you are using to service your debt.',
	additional_info: 'Additional Info',
	RESIDE: 'Mortgage Loan',
	CARLOA: 'Car Loan',
	RENOVA: 'Renovation Loan',
	STUDYL: 'Study Loan',
	CREDIT: 'Credit Card Loan',
	PERSON: 'Personal Loan',
	OTHERS: 'Other Loans',
	INTONL: 'Interest Only Loan',
	total_monthly_liability: 'Total Monthly Liability',
	total_monthly_income: 'Total Monthly Income',
	income: 'Income',
	liability: 'Liability',
	check_out_latest_rates: 'Unlock your ideal mortgage rate: Explore fixed or variable options from top banks today!',
	calculate_affordability: 'Plan your dream home wisely! Calculate your loan affordability today for a stress-free house hunt tomorrow.',
	applicant_details: 'Applicant Details',
	main_applicant: 'Main Applicant',
	joint_applicant: 'Joint Applicant',
	recommended: 'Recommended'
};
